import { inject, Pipe, PipeTransform } from "@angular/core";
import { ProjectStatusService } from "@domain/project/project-status.service";
import { UserService } from "@domain/user/user.service";
import { map, of } from "rxjs";

@Pipe({
  name: "translateProjectStatus",
  standalone: true,
  pure: false,
})
export class TranslateProjectStatusPipe implements PipeTransform {
  private projectStatusService: ProjectStatusService = inject(ProjectStatusService);
  private userService: UserService = inject(UserService);

  transform(status?: string | null) {
    return status
      ? this.userService.businessScope$.pipe(
          map((scope) => {
            const result = this.projectStatusService.translate(status, scope);
            return result;
          }),
        )
      : of("");
  }
}
